var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containers"},[_c('div',{staticClass:"output-area"},[_c('div',{ref:"mathOutput"})])])}
var staticRenderFns = []

export { render, staticRenderFns }